import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import "./index.css";
import EditIntroducerModal from "./components/EditIntroducerModal";
import AddIntroducerModal from "./components/AddIntroducerModal";

import { TerritoryOptions } from "../../Constants/brand";

const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon,
};

const user_icon = require("../../assets/media/user.png");

class Introducer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      introducers: [],
      selectedUser: null,
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });
      Firebase.getAllIntroducers((res) => {
        this.setState({ introducers: res });
      });
    }
  }

  addIntroducer = async (introducer_data) => {
    try {
      let introducer_id = await Firebase.addIntroducer(introducer_data);
      console.log("introducer added", introducer_id);
    } catch (error) {
      console.log("error", error);
    }
  };
  saveIntroducer = (profile) => {
    const { selectedUser } = this.state;
    let id = selectedUser.id;
    console.log("profile updated", profile);
    console.log("id", id);
    Firebase.updateIntroducer(id, profile);
    // try {
    //   let introducer_id = await Firebase.addIntroducer(introducer_data);
    //   console.log("introducer added",introducer_id);
    // } catch (error) {
    //   console.log("error",error);
    // }
  };

  editIntroducer = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  render() {
    const {
      username,
      role,
      logo,
      brand,
      brand_name,
      introducers,
      selectedUser,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
        />
        <main id="main-container">
          <div className="home-content super-admins-container">
            <div className="introducer-content">
              <div>
                <div className="member-row">
                  <button
                    type="button"
                    className="btn add-user"
                    data-toggle="modal"
                    data-target="#add_introducer"
                  >
                    Create an introducer
                  </button>
                </div>
                <div className="member-row">
                  <p className="member-item header">Introducer partners</p>
                  <p className="member-item header">Territory</p>
                  <p className="member-item header">Sales</p>
                  <p className="member-item header">% on revenue</p>
                  <p className="member-item header">% on Cashback</p>
                  <p className="member-item header">% on EcoAds</p>
                  <div className="introducer-actions-container"></div>
                </div>
                {introducers.map((item, index) => {
                  return (
                    <div className="member-row" key={index}>
                      <div className="member-item profile">
                        <div
                          className="avatar"
                          style={{
                            backgroundImage: `url(${
                              item.avatar_url || user_icon
                            })`,
                          }}
                          width="50"
                          alt="icon"
                        />
                        <p>{item.user_name}</p>
                      </div>
                      <div className="member-item">
                        <img
                          src={TerritoryIcon[item.user_territory]}
                          width="50"
                          height="50"
                        />
                      </div>
                      <p className="member-item">{item.user_sales}</p>
                      <p className="member-item">{item.user_revenue}%</p>
                      <p className="member-item">{item.user_cashback}%</p>
                      <p className="member-item">{item.user_ecoAds}%</p>
                      <div className="introducer-actions-container">
                        <button
                          type="button"
                          className="btn"
                          data-toggle="modal"
                          data-target="#edit_introducer"
                          onClick={this.editIntroducer(item)}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </main>
        <AddIntroducerModal addIntroducer={this.addIntroducer} />
        <EditIntroducerModal
          onSave={this.saveIntroducer}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default Introducer;



// WEBPACK FOOTER //
// ./src/screens/Introducer/index.js